<template>
  <RouterView />
</template>

<script>
import { READ } from '@/plugins/user'
export default {
  data () {
    return {
      title: 'Reports',
      breadcrumb: {
        name: 'Reports',
        route: { name: 'reports' }
      },
      sidebar: [
        {
          hidden: this.$user.cannot(READ, 'legacy_reports_freight'),
          icon: ['fal', 'box-alt'],
          route: { name: 'reports-freight' },
          name: 'Freight'
        },
        {
          hidden: this.$user.cannot(READ, 'legacy_reports_invoicing'),
          icon: ['fal', 'file-invoice-dollar'],
          route: { name: 'reports-invoice' },
          name: 'Invoicing'
        },
        {
          hidden: this.$user.cannot(READ, 'legacy_reports_invoicing'),
          icon: ['fal', 'user-alt'],
          route: { name: 'reports-account' },
          name: 'Accounts'
        },
        {
          hidden: this.$user.cannot(READ, 'legacy_reports_freight'),
          icon: ['fal', 'user'],
          route: { name: 'reports-legacy-accounts' },
          name: 'Accounts (Old)'
        },
        {
          hidden: this.$user.cannot(READ, 'legacy_reports_freight'),
          icon: ['fal', 'box-alt'],
          route: { name: 'reports-legacy-freight' },
          name: 'Freight (Old)'
        },
        {
          hidden: this.$user.cannot(READ, 'legacy_reports_freight'),
          icon: ['fal', 'chart-line'],
          route: { name: 'reports-legacy-sales' },
          name: 'Sales (Old)'
        },
        {
          hidden: this.$user.cannot(READ, 'legacy_reports_invoicing'),
          icon: ['fal', 'file-invoice-dollar'],
          route: { name: 'reports-legacy-invoice' },
          name: 'Invoicing (Old)'
        }
      ]
    }
  }
}
</script>
